import React from 'react'
import { useParams } from 'react-router-dom';
import Header from '../components/Header.js';
import Sidebar from '../components/sidebar.js';
import MainContentType from '../components/ContentTypes/MainContentType';

const ContentTypesScreen = () => {
    const {id} = useParams();
    return (
      <>
        <Sidebar />
        <main className="main-wrap">
          <Header />
          <MainContentType catalogId={id}/>
        </main>
      </>
    );
}

export default ContentTypesScreen